import React, { useEffect } from "react";
import { connect } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import { onMessageListener } from "./AppWrapper";
import "../node_modules/react-toastify/dist/ReactToastify.css";

const Notification = (props) => {
  const { firebaseMessage } = props;
  onMessageListener();
  useEffect(() => {
    if (firebaseMessage) {
      console.log("onMessageListener", firebaseMessage);
      toast.success(firebaseMessage?.notification?.title);
    }
  }, [firebaseMessage]);

  return (
    <div>
      <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        theme="light"
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    organizationInfo: state.organizationInfo.data,
    firebaseMessage: state.globalStoreInfo.firebaseMessage,
  };
};

export default connect(mapStateToProps)(Notification);
